import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import {
  RouterModule,
  Routes
} from '@angular/router';

import { FormlyModule } from '@ngx-formly/core';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';

import { MaterialModule } from '@app/material/material.module';
import { SharedModule } from '@shared/shared.module';
import { SecurityAccessGuardService } from '@app/shared/guards/security-access.guard';
import { QuestionDialogModule } from './dialogs/question-dialog/question-dialog.module';
import { TabDialogModule } from './dialogs/tab-dialog/tab-dialog.module';
import {
  QuestionnaireAddTemplateDialogModule
} from './dialogs/questionnaire-add-template-dialog/questionnaire-add-template-dialog.module';

import { QuestionnaireComponent } from './questionnaire.component';
import {
  CustomFieldRadioComponent
} from '@shared/components/formly-custom-templates/custom-field-radio/custom-field-radio.component';
import { CustomFieldInputComponent
} from '@shared/components/formly-custom-templates/custom-field-input/custom-field-input.component';
import { CheckboxWrapperComponent
} from '@shared/components/formly-custom-templates/custom-field-checkbox/checkbox-wrapper.component';
import {
  CustomFieldDatePickerComponent
} from '@shared/components/formly-custom-templates/custom-field-date-picker/custom-field-date-picker.component';
import {
  CustomFieldCheckboxComponent
} from '@shared/components/formly-custom-templates/custom-field-checkbox/custom-field-checkbox.component';
import {
  RadioWrapperComponent
} from '@app/shared/components/formly-custom-templates/custom-field-radio/radio-wrapper.component';
import {
  CustomFieldTextareaComponent
} from '@app/shared/components/formly-custom-templates/custom-field-textarea/custom-field-textarea.component';
import { CustomFieldHealthAndSafetyResponsibilitiesComponent } from '@app/shared/components/formly-custom-templates/custom-field-health-and-safety-responsibilities/custom-field-health-and-safety-responsibilities.component';
import { CustomFieldResponsibilityListComponent } from '@app/shared/components/formly-custom-templates/custom-field-responsibility-list/custom-field-responsibility-list.component';
import { OutputDialogModule } from './dialogs/output-dialog/output-dialog.module';
import { ResponsibilitiesListDialogModule } from './dialogs/responsibilities-list-dialog/responsibilities-list-dialog.module';
import { QuestionnaireAccessGuard } from '@app/shared/guards/questionnaire-access.guard';


export { QuestionnaireComponent } from './questionnaire.component';

const appRoutes: Routes = [
  {
    path: 'questionnaires/questionnaire/:id',
    component: QuestionnaireComponent,
    canActivate: [SecurityAccessGuardService, QuestionnaireAccessGuard],
  }
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    FormlyBootstrapModule,
    MaterialModule,
    QuestionDialogModule,
    TabDialogModule,
    OutputDialogModule,
    ResponsibilitiesListDialogModule,
    QuestionnaireAddTemplateDialogModule,
    FormlyModule.forRoot({
      types: [
        { name: 'custominput', component: CustomFieldInputComponent },
        { name: 'date', component: CustomFieldDatePickerComponent },
        { name: 'customcheckbox', component: CustomFieldCheckboxComponent },
        { name: 'customradio', component: CustomFieldRadioComponent },
        { name: 'textarea', component: CustomFieldTextareaComponent },
        { name: 'customResponsibilitiesList', component: CustomFieldResponsibilityListComponent },
        { name: 'customHealthAndSafetyResponsibilities', component: CustomFieldHealthAndSafetyResponsibilitiesComponent }
      ],
      wrappers: [
        { name: 'customcheckboxwrapper', component: CheckboxWrapperComponent },
        { name: 'customradiowrapper', component: RadioWrapperComponent }
      ]
    }),
    RouterModule.forChild(appRoutes)
  ],
  declarations: [QuestionnaireComponent],
  exports: [QuestionnaireComponent]
})
export class QuestionnaireModule { }
